import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import "./EventGames.css";

// Giả sử bạn có video từ Youtube hoặc file local
// Thay thế URL bằng video thực tế của bạn
const eventData = [
  {
    title: "INTERACTIVE WALL CLIMBING - CRESCENT MALL",
    description: "Giải pháp leo núi tương tác đột phá kết hợp cảm biến chuyển động và công nghệ Projection Mapping. Trải nghiệm thể thao kỹ thuật số sống động này không chỉ kích thích vận động mà còn là 'thỏi nam châm' thu hút sự chú ý, tạo dấu ấn thương hiệu mạnh mẽ tại các trung tâm thương mại lớn.",
    videoUrl: "https://www.youtube.com/embed/BOUKdvBrBco",
    isYoutube: true
  },
  {
    title: "STRIKE A POSE AI ACTIVATION",
    description: "Ứng dụng trí tuệ nhân tạo (AI Pose Estimation) tiên tiến để nhận diện và mô phỏng chuyển động cơ thể theo thời gian thực. Đây là giải pháp Brand Activation hoàn hảo, giúp khách hàng tương tác trực tiếp với thương hiệu thông qua những thử thách vận động thú vị, tạo nên sự gắn kết mạnh mẽ.",
    videoUrl: "https://www.youtube.com/embed/ss6qMXWc9JU", 
    isYoutube: true
  },
  {
    title: "BOTTLE SHOOTER",
    description: "Thử thách sự chính xác và phản xạ nhanh với trò chơi bắn chai tương tác. Sử dụng mô hình súng hiện đại tích hợp phản hồi lực (haptic feedback), người chơi sẽ cảm nhận được độ giật chân thực trong từng phát bắn, mang lại cảm giác phấn khích và kịch tính tột độ.",
    videoUrl: "https://www.youtube.com/embed/Mrn6RCMzRDQ", 
    isYoutube: true
  },
  {
    title: "CIRCUS",
    description: "Bước vào không gian rực rỡ và náo nhiệt của rạp xiếc với những thử thách bắn súng vui nhộn. Trò chơi kết hợp đồ họa bắt mắt và âm thanh sống động, là điểm nhấn lý tưởng cho các sự kiện gia đình hoặc khu vui chơi giải trí, thu hút mọi ánh nhìn từ xa.",
    videoUrl: "https://www.youtube.com/embed/2yRZyu3wD00", 
    isYoutube: true
  },
  {
    title: "GLASS SHOOTER",
    description: "Một trải nghiệm bắn súng tương tác đầy lôi cuốn, nơi người chơi phải tập trung cao độ để hạ gục các mục tiêu thủy tinh mong manh. Công nghệ cảm biến chính xác giúp ghi nhận mọi tác động nhỏ nhất, tạo nên một cuộc đua điểm số đầy gay cấn và hấp dẫn.",
    videoUrl: "https://www.youtube.com/embed/xgM9rlXJcVk", 
    isYoutube: true
  },
  {
    title: "SPACE SHOOTER",
    description: "Hành trình chinh phục thiên hà với trò chơi bắn súng không gian tốc độ cao. Người chơi sẽ nhập vai phi công chiến đấu, sử dụng vũ khí tương tác để bảo vệ lãnh địa khỏi các thế lực ngoài hành tinh, mang lại trải nghiệm khoa học viễn tưởng sống động và hiện đại.",
    videoUrl: "https://www.youtube.com/embed/5xAl63yI7MQ", 
    isYoutube: true
  },
  {
    title: "CLASSIFY SHOOTER",
    description: "Sự kết hợp độc đáo giữa kỹ năng bắn súng và khả năng tư duy phân loại nhanh nhạy. Trò chơi đòi hỏi người chơi phải nhắm trúng các mục tiêu theo đúng yêu cầu, biến những màn giải trí thông thường thành một thử thách trí tuệ đầy mới lạ và gây nghiện.",
    videoUrl: "https://www.youtube.com/embed/3-0jsbyZd7o", 
    isYoutube: true
  },
];

function EventGames() {
  return (
    <Container fluid className="event-section">
      <Particle />
      <Container>
        <h1 className="project-heading" style={{ paddingBottom: "30px" }}>
          Highlight <strong className="purple">Event Games </strong>
        </h1>
        
        {eventData.map((event, index) => (
          <Row key={index} className={`event-row ${index % 2 !== 0 ? "row-reverse" : ""}`}>
            {/* Cột Video/Media */}
            <Col md={7} className="event-media-container">
              <div className="video-wrapper">
                {event.isYoutube ? (
                  <iframe
                    src={event.videoUrl}
                    title={event.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <video controls>
                    <source src={event.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            </Col>

            {/* Cột Nội dung mô tả */}
            <Col md={5} className="event-text-container">
              <h3 className="event-title">
                <span className="purple">{index + 1}. </span>
                {event.title}
              </h3>
              <p className="event-description">
                {event.description}
              </p>
              {/* Bạn có thể thêm nút "Xem thêm" hoặc link liên quan tại đây */}
            </Col>
          </Row>
        ))}
      </Container>
    </Container>
  );
}

export default EventGames;
